import { useEffect, useState } from "react";
import { GetCampaignConfig } from "../service/service";

// Returns the campaign config object only when campaign mode is enabled;
// null while loading, when disabled, or when the backend is unreachable —
// so `config && <CampaignUI/>` is the single kill switch everywhere.
export default function useCampaignConfig() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cancelled = false;
    GetCampaignConfig()
      .then((result) => {
        if (!cancelled && result?.status && result.data?.enabled) {
          setConfig(result.data);
        }
      })
      .catch(() => {
        // Campaign UI simply doesn't render; the site behaves as today.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
